export default __webpack_public_path__ + "static/media/preloader.0fd055b5.gif";